<template>
  <div v-if="confirmDialog.visible" class="confirm-dialog p-dialog surface-card p-4 border-round shadow-4" style="max-width: 450px; z-index: 1100;">
    <div class="confirm-dialog-content text-center">
      <h3 class="m-0 text-xl font-bold text-900 mb-2">Conferma Esito Documento</h3>
      <p class="text-600 m-0 mb-4">
        Stai per impostare lo stato del documento a 
        <b :class="confirmDialog.approvatoValue === 1 ? 'text-green-600' : 'text-red-600'">
          {{ confirmDialog.approvatoValue === 1 ? 'OK (Approvato)' : 'KO (Rifiutato / Ignorato)' }}
        </b>.
      </p>
      <div class="flex justify-content-center gap-3">
        <Button 
          @click="confirmDialogAccept" 
          :label="confirmDialog.approvatoValue === 1 ? 'Conferma OK' : 'Conferma KO'" 
          :class="confirmDialog.approvatoValue === 1 ? 'p-button-success' : 'p-button-danger'" 
        />
        <Button @click="confirmDialogReject" label="Annulla" class="p-button-secondary p-button-outlined" />
      </div>
    </div>
  </div>

  <Dialog v-model:visible="editDialog.visible" header="Modifica Documento" :modal="true" :style="{ width: '400px' }">
    <div class="field mb-4">
      <label for="tipo" class="block mb-2 font-bold">Tipologia Documento</label>
      <Dropdown id="tipo" v-model="editDialog.data.cod_type_doc" :options="docs" optionLabel="nome" optionValue="id" placeholder="Seleziona Tipologia" class="w-full" />
    </div>
    <div class="field mb-4">
      <label for="scadenza" class="block mb-2 font-bold">Data Scadenza</label>
      <Calendar id="scadenza" v-model="editDialog.data.datascadenza" dateFormat="dd/mm/yy" class="w-full" />
    </div>
    <template #footer>
      <Button label="Annulla" icon="pi pi-times" @click="editDialog.visible = false" class="p-button-text" />
      <Button label="Salva" icon="pi pi-check" @click="saveDocumentEdit" autofocus />
    </template>
  </Dialog>

  <Loader v-if="loading" />
  
  <div class="p-2">
    <Button
      @click="goToTypeCorsoPage"
      label="Vai alla Gestione documenti per tipi di corsi"
      class="p-button-outlined"
    />
  </div>

  <Card>
    <template v-slot:content>
      <div class="p-2 flex flex-wrap gap-2">
        <Button
          v-for="doc in docs"
          :key="doc.id"
          :label="doc.nome"
          :class="['p-button', { 'p-button-danger': doc.id === type_doc }]"
          @click="setDocType(doc)"
        />
      </div>
    </template>
  </Card>

  <Card class="mt-3">
    <template v-slot:title>
      <h3 class="m-0">Documenti da verificare: {{ nome_doc }}</h3>
    </template>
    <template v-slot:content>
      <div class="p-4 text-center text-600 font-medium" v-if="logData.length == 0">
        <i class="pi pi-check-circle text-green-500 text-3xl mb-2 block"></i>
        Non ci sono documenti da validare per questa tipologia
      </div>
      <DataTable v-else :value="logData" responsiveLayout="scroll" class="p-datatable-sm p-datatable-striped">
        <Column field="creation_time" header="Data invio" />
        <Column field="nomeutente" header="Nome Utente">
          <template #body="{data}">
            <Button class="p-button-link p-0 font-bold text-blue-700" severity="help" @click="goToAtleta(data.id_atleta)">
              {{ capitalize(data.nomeutente) }}
            </Button>
          </template>
        </Column>
        <Column field="file" header="Documento">
          <template #body="{data}">
            <Button class="p-button-link p-0 text-blue-700" severity="help" @click="getDocUrl(data.path)">
              <i class="pi pi-file mr-1"></i>{{ data.nome }}
            </Button>
          </template>
        </Column>
        <Column field="tipo" header="Tipologia" />
        <Column field="datascadenza" header="Data scadenza" />
        <Column field="dispositivo" header="Dispositivo" />
        
        <Column header="Corsi Attivi">
          <template #body="{data}">
            <div v-if="data.active_courses && data.active_courses.length">
              <div v-for="c in data.active_courses" :key="c.id" class="mb-1">
                <Button class="p-button-link p-0 text-blue-700 block text-left" severity="help" @click="goToCorso(c.id)">
                  {{ c.nome }}
                </Button>
              </div>
            </div>
            <span v-else>-</span>
          </template>
        </Column>

        
        <!-- Validazione OK / KO -->
        <Column header="Esito Validazione" style="min-width: 170px" headerClass="text-center" bodyClass="text-center">
          <template #body="slotProps">
            <div class="flex justify-content-center gap-2">
              <Button 
                label="OK" 
                icon="pi pi-check" 
                class="p-button-success p-button-sm px-3" 
                @click="openConfirmDialog(slotProps.data.id, 1)" 
                v-tooltip.top="'Valida / Approva (OK)'"
              />
              <Button 
                label="KO" 
                icon="pi pi-times" 
                class="p-button-danger p-button-sm px-3" 
                @click="openConfirmDialog(slotProps.data.id, -1)" 
                v-tooltip.top="'Rifiuta / Ignora (KO)'"
              />
            </div>
          </template>
        </Column>

        <Column field="data_approvazione" header="Data approvazione" />
        <Column header="Azioni" headerClass="text-center" bodyClass="text-center">
          <template #body="slotProps">
            <Button icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary" @click="openEditDialog(slotProps.data)" v-tooltip.top="'Modifica tipo/scadenza'" />
          </template>
        </Column>
      </DataTable>
    </template>
  </Card>

  <Card class="mt-3">
    <template v-slot:title>
      <h3 class="m-0">Documenti di tipo "{{ nome_doc }}" per gruppo</h3>
    </template>
    <template v-slot:content>
      <Accordion :groups="logDataGruppi" />
    </template>
  </Card>
</template>

<script>
import { ref, onMounted, getCurrentInstance } from 'vue';
import Loader from "@/components/Loader.vue";
import Service from '@/services/levante-api/levante-api';
import { useToast } from 'primevue/usetoast';
import moment from 'moment';
import Card from '@/components/AccordionCardGroup.vue';
import Accordion from '@/components/AccordionGroup.vue';
import Dialog from 'primevue/dialog';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';

export default {
  name: 'AppVerificaDocumenti',
  components: {
    Loader,
    Card,
    Accordion,
    Dialog,
    Calendar,
    Dropdown,
  },
  setup() {
    const loading = ref(true);
    const logData = ref([]);
    const logDataGruppi = ref([]);
    const docs = ref([]);
    const toast = useToast();
    const type_doc = ref(1);
    const nome_doc = ref("");
    const self = getCurrentInstance();
    const lifeTime = 3000;
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);

    const getDocUrl = (imgPath) => {
      window.open(`${process.env.VUE_APP_LEVANTE_API_URL}/../storage/app/public/${imgPath}`);
    };

    const setDocType = (doc) => {
      type_doc.value = doc.id;
      nome_doc.value = doc.nome;
      initData();
    };

    const goToAtleta = (idatleta) => {
      window.open(`/atleta/${idatleta}/dettagli`, '_blank');
    };

    const goToCorso = (idcorso) => {
      window.open(`/corso/${idcorso}/dettagli`, '_blank');
    };

    const goToTypeCorsoPage = () => {
      window.open(`/course-types`, '_blank');
    };

    const initData = () => {
      service.getDocumentiApp(type_doc.value).then((res) => {
        logData.value = res.items || [];
        logData.value = logData.value.map(item => ({
          creation_time: moment(item.creation_time).format('DD/MM/Y H:m'),
          data_approvazione: item.data_approvazione != null ? moment(item.data_approvazione).format('DD/MM/Y HH:mm:ss') : '',
          nomeutente: item.atleta,
          datascadenza: moment(item.datascadenza).format('DD/MM/Y'),
          tipo: item.tipo,
          file: item.file,
          path: item.path,
          nome: item.nome,
          id_atleta: item.id_atleta,
          id: item.id_documento,
          approvato: item.approvato,
          dispositivo: item.os === 0 ? 'Android' : 'iOS',
          active_courses: item.active_courses ? item.active_courses.split('||').map(c => {
            const [id, nome] = c.split('|');
            return { id, nome };
          }) : [],
        }));
      });

      service.getDocumentiGruppo(type_doc.value).then((res) => {
        logDataGruppi.value = res.items || [];
      });
    };

    const getTypesofFiles = async () => {
      await service.getTypesOfFiles().then((res) => {
        docs.value = res.items || [];
        if (docs.value.length > 0) {
          nome_doc.value = docs.value[0].nome;
          type_doc.value = docs.value[0].id;
        }
      });
    };

    onMounted(() => { 
      loading.value = true;
      const promises = [getTypesofFiles(), initData()];
      
      Promise.all(promises)
        .finally(() => {
          loading.value = false;
        });
    });

    const confirmDialog = ref({
      visible: false,
      id: null,
      approvatoValue: null
    });

    const openConfirmDialog = (id, targetApprovatoVal) => {
      confirmDialog.value.visible = true;
      confirmDialog.value.id = id;
      confirmDialog.value.approvatoValue = targetApprovatoVal;
    };

    const confirmDialogAccept = () => {
      setDocumentStatus(confirmDialog.value.id, confirmDialog.value.approvatoValue);
      confirmDialog.value.visible = false;
    };

    const confirmDialogReject = () => {
      confirmDialog.value.visible = false;
    };

    const setDocumentStatus = async (id, approvatoValue) => {
      loading.value = true;
      try {
        let fd = new FormData();  
        fd.append('approvato', approvatoValue);
        await service.updateApprovaDocumento(id, fd);  
        
        const labelText = approvatoValue === 1 ? 'OK (Approvato)' : 'KO (Rifiutato / Ignorato)';
        const severity = approvatoValue === 1 ? 'success' : 'warn';
        
        toast.add({ 
          severity: severity, 
          summary: 'Successo', 
          detail: `Esito ${labelText} registrato con successo`, 
          life: lifeTime 
        });

        initData();
      } catch (error) {
        toast.add({ 
          severity: 'error', 
          summary: 'Errore', 
          detail: 'Errore durante l\'aggiornamento dell\'esito del documento', 
          life: lifeTime 
        });
      } finally {
        loading.value = false;
      }
    };

    const editDialog = ref({
      visible: false,
      data: {
        id: null,
        cod_type_doc: null,
        datascadenza: null
      }
    });

    const openEditDialog = (rowData) => {
      const [day, month, year] = rowData.datascadenza.split('/');
      editDialog.value.data = {
        id: rowData.id,
        cod_type_doc: type_doc.value,
        datascadenza: new Date(year, month - 1, day)
      };
      editDialog.value.visible = true;
    };

    const saveDocumentEdit = async () => {
      loading.value = true;
      try {
        let fd = new FormData();
        fd.append('cod_type_doc', editDialog.value.data.cod_type_doc);
        fd.append('datascadenza', moment(editDialog.value.data.datascadenza).format('YYYY-MM-DD'));
        
        await service.updateApprovaDocumento(editDialog.value.data.id, fd);
        toast.add({ severity: 'success', summary: 'Successo', detail: 'Documento aggiornato con successo', life: lifeTime });
        editDialog.value.visible = false;
        initData();
      } catch (error) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'aggiornamento del documento', life: lifeTime });
      } finally {
        loading.value = false;
      }
    };

    const capitalize = (str) => {
      if (!str) return '';
      return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    };

    return {
      loading,
      logDataGruppi,
      capitalize,
      logData,
      confirmDialog,
      openConfirmDialog,
      confirmDialogAccept,
      confirmDialogReject,
      getDocUrl,
      setDocType,
      docs,
      type_doc,
      nome_doc,
      goToAtleta,
      goToCorso,
      goToTypeCorsoPage,
      editDialog,
      openEditDialog,
      saveDocumentEdit
    };
  },
}
</script>

<style scoped>
.confirm-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.25);
  z-index: 1100;
  border-radius: 8px;
}
</style>
